import { Typography, useTheme } from '@mui/material';
import { DownloadOption } from 'types';
import useRadioButtonLocales from '../hooks';

type PropTypes = {
  downloadOption: DownloadOption;
  isSelected: boolean;
};

const RadioTitle = ({ downloadOption, isSelected }: PropTypes) => {
  const theme = useTheme();

  const { title, subtitle } = useRadioButtonLocales(downloadOption);

  return (
    <>
      <Typography
        variant="body2"
        data-testid={`radio-button-${downloadOption}-title`}
        aria-checked={isSelected}
        role="radio"
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: theme.palette.grey[900],
          fontSize: 12,
          [theme.breakpoints.down('desktop')]: {
            display: 'none',
          },
        }}
        data-testid={`radio-button-${downloadOption}-subtitle`}
      >
        {subtitle}
      </Typography>
    </>
  );
};

export default RadioTitle;
